import Lottie from 'lottie-react';
import servers from '../jsons/servers.json';

const Server = props => {
  return <Lottie animationData={servers} {...props} />;
};

export default Server;
